import { useState } from "react";
import { Card } from "react-bootstrap";
import { MdEdit } from "react-icons/md";
import { ROLE_GROUPS, MODULES } from "../../../auth/roles";
import StatusProjektaModal from "./StatusProjektaModal";
import RoleGuard from "../../../auth/RoleGuard";
import { useProjectDetailsContext } from "../../../context/ProjectDetailsContext";

const StatusProjektaPanel = () => {
  const [showModal, setShowModal] = useState(false);
  const { project, isLoading } = useProjectDetailsContext();

  return (
    <>
      <Card className="status-projekta-panel">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <span>Status projekta: </span>
            {isLoading ? (
              <span className="text-muted">Nalaganje...</span>
            ) : (
              <span className="text-success">{project?.status}</span>
            )}
          </div>
          <RoleGuard
            moduleKey={MODULES.PROJEKTI}
            roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
            vodilnaClanicaProjektaID={project?.clanicaID}
          >
            <button
              className="btn btn-sm btn-outline-primary border-0"
              onClick={() => setShowModal(true)}
            >
              <span className="d-flex align-items-center gap-1">
                Spremeni status <MdEdit />
              </span>
            </button>
          </RoleGuard>
        </div>
      </Card>
      {showModal && (
        <StatusProjektaModal
          show={showModal}
          onHide={() => setShowModal(false)}
          currentStatus={project}
        />
      )}
    </>
  );
};

export default StatusProjektaPanel;
